export enum PossibleStates {
  Cargado = "C",
  Pendiente = "P",
  Aprobado = "A",
  Rechazado = "R",
  Cargando="CN"
}

export const translatedStates = {
  C: "Cargado",
  P: "Pendiente",
  A: "Aprobado",
  R: "Rechazado",
  CN:"Cargando"
};
